export default "__VITE_ASSET__79ff8eee__"